var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VAutocomplete',_vm._g({attrs:{"outlined":"","disabled":_vm.disabled,"value":_vm.value,"items":_vm.racks,"rules":_vm.rules,"loading":_vm.loading,"item-text":"rack","item-value":"id","label":"Rack","return-object":"","clearable":""}},_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }